import Image from "../images/RegistraionImageDes.png";
import TextField from "@mui/material/TextField";
import LoginImg from "../images/loginDoctorImage.webp";
import Container from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { encryptData } from "../Services/TabServices";
import { useDispatch } from "react-redux";
import { closeSignupModal, openLoginModal } from "../reduxtool/action";
import logo from "../images/logoNew.png";
import CryptoJS from "crypto-js";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const MainContainer = styled.div`
  display: flex;
  align-items: center;
`;

const TextContainer = styled.div`
  padding: 20px;
`;

export default function Registration() {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [showPage, setShowPage] = useState(true);
  const [error, setError] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const [formData, setFormData] = useState({
    patientName: "",
    email: "",
    gender: "",
    phoneNo: "",
    address: "",
    adharNo: "",
    dob: null as Dayjs | null,
    otp: "",
  });
  const [otpMethod, setOtpMethod] = useState("sms");
  const [formDataOtp, setFormDataOtp] = useState({ otp: "" });
  const [verifyOtpPage, setVerifyOtpPage] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isOtpSend, setOtpSent] = useState(false);
  const [encryptedOTP, setEncriptedOtp] = useState("");
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    let interval: any;
    if (timer > 0) {
      interval = setInterval(() => setTimer((t) => t - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  // ✅ FIXED: General handleChange — other fields unchanged
  const handleChange = (e: any) => {
    e.stopPropagation();
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // ✅ FIXED: Dedicated phone handler with all 3 validations
  const handlePhoneChange = (e: any) => {
    e.stopPropagation();
    const { name, value } = e.target;
    if (!/^\d*$/.test(value)) return;           // digits only
    if (value.length > 10) return;              // max 10 digits
    if (value.length === 1 && !/^[6-9]$/.test(value)) return; // first digit 6–9
    setFormData({ ...formData, [name]: value });
  };

  // ✅ Live validation state
  const isMobileValid =
    formData.phoneNo.length === 0 ||
    /^[6-9]\d{0,9}$/.test(formData.phoneNo);



  const handleDateChange = (newValue: Dayjs | null) => {
    setFormData({ ...formData, dob: newValue });
  };

  const handleChangeOtp = (e: any) => {
    e.stopPropagation();
    const { name, value } = e.target;
    if (!/^\d*$/.test(value)) return;
    if (value.length > 6) return;
    setFormDataOtp({ ...formDataOtp, [name]: value });
  };

  const handleSendOtp = async () => {
    setError("");

    if (!formData.patientName || formData.patientName.trim().length < 2) {
      setError("Please enter a valid full name (minimum 2 characters).");
      return;
    }

    if (!formData.phoneNo || formData.phoneNo.trim() === "") {
      setError("Please enter your mobile number.");
      return;
    }

    const numberRegex = /^[6-9]\d{9}$/;
    if (!numberRegex.test(formData.phoneNo)) {
      setError("Please enter a valid 10-digit mobile number starting with 6-9.");
      return;
    }

    if (!formData.dob) {
      setError("Please select your date of birth.");
      return;
    }

    const dobDate = formData.dob.toDate();
    const today = new Date();
    const hundredYearsAgo = new Date();
    hundredYearsAgo.setFullYear(today.getFullYear() - 100);

    if (dobDate > today) {
      setError("Date of Birth cannot be in the future.");
      return;
    }

    if (dobDate < hundredYearsAgo) {
      setError("Date of Birth cannot be older than 100 years.");
      return;
    }

    if (!formData.gender || formData.gender.trim() === "") {
      setError("Please select your gender.");
      return;
    }

    if (!executeRecaptcha) {
      setLoading(false);
      return;
    }

    const recaptchaToken = await executeRecaptcha("callback_request");
    if (!recaptchaToken) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/OTPForSignUp`,
        {recaptchaToken},
        {
          params: {
            PhoneNo: formData.phoneNo,
            SmsType: otpMethod === "sms" ? "M" : "W"
          },
        }
      );

      setEncriptedOtp(response.data[0].encryptedOtp);
      setVerifyOtpPage(true);
      setOtpSent(true);
      setTimer(30);
    } catch (error) {
      console.error("Error sending OTP", error);
      if (axios.isAxiosError(error) && error.response?.status === 409) {
        setError("You are already registered.");
        setTimeout(() => dispatch(closeSignupModal()), 2000);
      } else {
        setError("Failed to send OTP.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyAndRegister = async (e: any) => {
    e.preventDefault();

    if (formDataOtp.otp.length !== 6) {
      setError("Please enter the 6-digit OTP.");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const secretKey = "12345678912345698745632165498712";
      const EncryptionIV = "1234569874123659";
      const bytes = CryptoJS.AES.decrypt(
        encryptedOTP,
        CryptoJS.enc.Utf8.parse(secretKey),
        { iv: CryptoJS.enc.Utf8.parse(EncryptionIV) }
      );
      const decryptedOtp = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedOtp) {
        setError("OTP expired. Please request a new one.");
        return;
      }

      if (decryptedOtp !== formDataOtp.otp) {
        setError("Invalid OTP. Please try again.");
        return;
      }

      const payload = {
        ...formData,
        dob: formData.dob ? formData.dob.format("YYYY-MM-DD") : "",
        otp: formDataOtp.otp,
      };

      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/PatientRegistration`,
        payload
      );

      setShowSuccessPopup(true);
      setFormData({
        patientName: "",
        email: "",
        gender: "",
        phoneNo: "",
        address: "",
        adharNo: "",
        dob: null,
        otp: "",
      });
      setVerifyOtpPage(false);
      setFormDataOtp({ otp: "" });

      setTimeout(() => {
        setShowSuccessPopup(false);
        setShowPage(false);
        dispatch(closeSignupModal());
        dispatch(openLoginModal());
      }, 2000);
    } catch (error: any) {
      console.error("Registration error:", error);
      if (error.response?.status === 400) {
        setError("Invalid registration data. Please check your information and try again.");
      } else if (error.response?.status === 409) {
        setError("Phone number is already registered. Please use a different number.");
      } else if (error.response?.data?.message) {
        setError(error.response.data.message);
      } else {
        setError("Registration failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const isFormValid = () => {
    return (
      formData.patientName?.trim().length >= 2 &&
      formData.phoneNo?.trim().length === 10 &&
      /^[6-9]\d{9}$/.test(formData.phoneNo) &&
      formData.dob &&
      formData.gender &&
      formData.address &&
      acceptedTerms
    );
  };

  return (
    <Container
      open={true}
      aria-labelledby="modal-modal-title"
      sx={{
        zIndex: 1300,
        opacity: showPage ? 1 : 0,
        transition: "opacity 0.3s ease",
      }}
      onClick={(e: any) => {
        if (e.target === e.currentTarget) {
          dispatch(closeSignupModal());
        }
      }}
    >
      <div>
        {/* ✅ SUCCESS POPUP */}
        {showSuccessPopup && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1500] p-4">
            <div className="bg-white rounded-2xl p-6 sm:p-8 max-w-md w-full text-center shadow-2xl">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-6 h-6 sm:w-8 sm:h-8 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
              <h2 className="text-lg sm:text-2xl font-bold text-gray-900 mb-2">
                Registration Successful!
              </h2>
              <p className="text-gray-600 mb-4 text-xs sm:text-base">
                You have successfully registered with RAMA Hospital.
              </p>
              <div className="flex items-center justify-center space-x-2 text-teal-600">
                <svg
                  className="w-4 h-4 sm:w-5 sm:h-5 animate-spin"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                  />
                </svg>
                <span className="text-xs sm:text-sm font-medium">
                  Closing modal...
                </span>
              </div>
            </div>
          </div>
        )}

        {/* ==================== MOBILE VIEW (< 768px) ==================== */}
        <div
          className={`block md:hidden absolute top-1/2 left-1/2 transform 
            -translate-x-1/2 -translate-y-1/2 bg-white shadow-2xl outline-none rounded-2xl 
            w-[85vw] sm:w-[80vw] max-h-[90vh] overflow-y-auto transition-all duration-300
            ${showPage ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}
        >
          <CloseIcon
            onClick={() => {
              setShowPage(false);
              setTimeout(() => dispatch(closeSignupModal()), 300);
            }}
            className="float-right relative w-7 h-7 sm:w-8 sm:h-8 right-2 sm:right-1 top-2 sm:top-1 cursor-pointer rounded-full hover:bg-gray-100 transition-all duration-200"
          />

          <div className="px-4 sm:px-5 py-5 sm:py-6">
            {verifyOtpPage ? (
              // ---------- Mobile OTP Verification ----------
              <div className="text-center space-y-4 sm:space-y-5">
                <div className="w-full max-w-[150px] flex items-center justify-center mx-auto mb-3">
                  <img src={logo} alt="" className="h-auto" />
                </div>
                <h1 className="text-xl sm:text-2xl font-bold text-gray-900">
                  Verify Now
                </h1>
                <p className="text-gray-600 text-xs sm:text-sm leading-relaxed px-2">
                  A verification code has been sent to your mobile number.
                </p>

                <form
                  onSubmit={handleVerifyAndRegister}
                  className="space-y-3 sm:space-y-4"
                >
                  <div className="space-y-3 sm:space-y-4">
                    <TextField
                      required
                      label="Mobile No"
                      name="phoneNo"
                      value={formData.phoneNo}
                      fullWidth
                      disabled
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <span className="mr-2 text-xs sm:text-sm">+91</span>
                        ),
                        style: { backgroundColor: "rgba(249, 250, 251, 0.8)" },
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "42px",
                          borderRadius: "12px",
                          fontSize: "13px",
                        },
                        "& .MuiInputLabel-root": { fontSize: "13px" },
                      }}
                      onKeyDown={(e) => e.stopPropagation()}
                    />

                    <TextField
                      required
                      label="Enter Code"
                      name="otp"
                      value={formDataOtp.otp}
                      fullWidth
                      size="small"
                      onChange={handleChangeOtp}
                      onKeyDown={(e) => e.stopPropagation()}
                      inputProps={{ inputMode: "numeric", maxLength: 6 }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "42px",
                          borderRadius: "12px",
                          fontSize: "13px",
                        },
                        "& .MuiInputLabel-root": { fontSize: "13px" },
                      }}
                    />
                  </div>

                  <div className="text-center py-2">
                    {timer > 0 ? (
                      <p className="text-gray-600 text-xs sm:text-sm">
                        Resend code in{" "}
                        <span className="font-semibold text-teal-600">
                          {timer}s
                        </span>
                      </p>
                    ) : (
                      <button
                        type="button"
                        onClick={handleSendOtp}
                        className="text-xs sm:text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors underline"
                      >
                        Resend OTP
                      </button>
                    )}
                  </div>

                  {error && (
                    <div className="bg-red-50 border-l-4 border-red-400 p-2 sm:p-3 rounded-lg">
                      <p className="text-red-700 text-xs sm:text-sm font-medium">
                        {error}
                      </p>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isLoading}
                    className={`w-full py-2.5 sm:py-3 rounded-lg text-white font-semibold text-sm sm:text-base transition-all duration-200 shadow-lg ${
                      isLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 active:scale-95"
                    }`}
                  >
                    {isLoading ? (
                      <div className="flex items-center justify-center space-x-2">
                        <svg
                          className="w-4 h-4 sm:w-5 sm:h-5 animate-spin"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8H4z"
                          />
                        </svg>
                        <span className="text-xs sm:text-sm">Verifying...</span>
                      </div>
                    ) : (
                      "Submit"
                    )}
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setVerifyOtpPage(false);
                      setError("");
                    }}
                    className="w-full py-2.5 sm:py-3 bg-white border-2 border-gray-200 text-gray-700 rounded-lg font-semibold text-sm sm:text-base hover:bg-gray-50 transition-all duration-200"
                  >
                    ← Go Back
                  </button>
                </form>
              </div>
            ) : (
              // ---------- Mobile Registration Form ----------
              <div className="text-center space-y-3 sm:space-y-4">
                <div className="w-full max-w-[150px] flex items-center justify-center mx-auto mb-3">
                  <img src={logo} alt="" className="h-auto" />
                </div>
                <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                  Create your account to get started
                </p>

                <div className="space-y-3 sm:space-y-4 text-left">
                  <div className="space-y-4">
                    {/* Full Name */}
                    <TextField
                      required
                      label="Full Name"
                      name="patientName"
                      value={formData.patientName}
                      fullWidth
                      size="small"
                      onChange={handleChange}
                      onKeyDown={(e) => e.stopPropagation()}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "38px",
                          borderRadius: "10px",
                          fontSize: "13px",
                        },
                        "& .MuiInputLabel-root": { fontSize: "12px" },
                      }}
                    />

                    {/* ✅ FIXED Mobile Number - Mobile View */}
                    <TextField
                      required
                      label="Mobile No"
                      name="phoneNo"
                      value={formData.phoneNo}
                      fullWidth
                      size="small"
                      onChange={handlePhoneChange}
                      onKeyDown={(e) => e.stopPropagation()}
                      error={!isMobileValid}
                      // helperText={mobileHelperText}
                      inputProps={{
                        inputMode: "numeric",
                        maxLength: 10,
                        pattern: "[6-9][0-9]{9}",
                      }}
                      InputProps={{
                        startAdornment: (
                          <span className="mr-2 text-xs">+91</span>
                        ),
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "38px",
                          borderRadius: "10px",
                          fontSize: "13px",
                        },
                        "& .MuiInputLabel-root": { fontSize: "12px" },
                      }}
                    />

                    {/* Date of Birth */}
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Date of Birth"
                        value={formData.dob}
                        onChange={handleDateChange}
                        maxDate={dayjs()}
                        minDate={dayjs().subtract(100, "year")}
                        slots={{
                          textField: (params) => (
                            <TextField
                              {...params}
                              required
                              fullWidth
                              size="small"
                              onKeyDown={(e) => e.stopPropagation()}
                              sx={{
                                "& .MuiInputBase-root": {
                                  height: "38px",
                                  borderRadius: "10px",
                                  fontSize: "13px",
                                },
                                "& .MuiInputLabel-root": { fontSize: "12px" },
                              }}
                            />
                          ),
                        }}
                        slotProps={{ popper: { sx: { zIndex: 1400 } } }}
                      />
                    </LocalizationProvider>

                    {/* Gender */}
                    <FormControl fullWidth size="small">
                      <InputLabel id="gender-label" sx={{ fontSize: "12px" }}>
                        Gender
                      </InputLabel>
                      <Select
                        labelId="gender-label"
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        label="Gender"
                        sx={{
                          borderRadius: "10px",
                          fontSize: "13px",
                        }}
                      >
                        <MenuItem value="M">Male</MenuItem>
                        <MenuItem value="F">Female</MenuItem>
                        <MenuItem value="O">Other</MenuItem>
                      </Select>
                    </FormControl>

                    {/* Email */}
                    <TextField
                      label="Email"
                      name="email"
                      value={formData.email}
                      fullWidth
                      size="small"
                      onChange={handleChange}
                      onKeyDown={(e) => e.stopPropagation()}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "38px",
                          borderRadius: "10px",
                          fontSize: "13px",
                        },
                        "& .MuiInputLabel-root": { fontSize: "12px" },
                      }}
                    />

                    {/* City */}
                    <TextField
                      required
                      label="City"
                      name="address"
                      value={formData.address}
                      fullWidth
                      size="small"
                      onChange={handleChange}
                      onKeyDown={(e) => e.stopPropagation()}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "38px",
                          borderRadius: "10px",
                          fontSize: "13px",
                        },
                        "& .MuiInputLabel-root": { fontSize: "12px" },
                      }}
                    />
                  </div>

                  {/* OTP Method Selection */}
                  <div className="space-y-2 py-2 bg-blue-50 border border-blue-200 rounded-lg p-2 text-left">
                    <p className="font-semibold text-xs">Send OTP via</p>
                    <div className="flex items-center gap-6 lg:gap-8">
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="radio"
                          name="otpMethod"
                          value="sms"
                          className="h-3 w-3"
                          checked={otpMethod === "sms"}
                          onChange={(e) => setOtpMethod(e.target.value)}
                        />
                        <span className="text-xs">SMS</span>
                      </label>
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="radio"
                          name="otpMethod"
                          value="whatsapp"
                          className="h-3 w-3"
                          checked={otpMethod === "whatsapp"}
                          onChange={(e) => setOtpMethod(e.target.value)}
                        />
                        <span className="text-xs">WhatsApp</span>
                      </label>
                    </div>
                  </div>

                  {/* Terms and Conditions */}
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-2">
                    <div className="flex items-start gap-2">
                      <input
                        type="checkbox"
                        id="terms"
                        checked={acceptedTerms}
                        onChange={(e) => setAcceptedTerms(e.target.checked)}
                        className="cursor-pointer mt-1 w-3 h-3"
                      />
                      <div className="text-xs sm:text-sm text-blue-700 leading-relaxed">
                        Get updates on Whatsapp, I agree to all the{" "}
                        <Link
                          to="/privacy"
                          className="text-teal-600 font-medium hover:underline"
                        >
                          Privacy Policy
                        </Link>{" "}
                        &{" "}
                        <Link
                          to="/terms_conditions"
                          className="text-teal-600 font-medium hover:underline"
                        >
                          T&C
                        </Link>
                        .
                      </div>
                    </div>
                  </div>

                  {error && (
                    <div className="bg-red-50 border-l-4 border-red-400 p-2 rounded-lg">
                      <p className="text-red-700 text-xs font-medium">{error}</p>
                    </div>
                  )}

                  {/* Create Account Button */}
                  <button
                    onClick={handleSendOtp}
                    disabled={!isFormValid() || isLoading}
                    className={`w-full py-2.5 sm:py-3 rounded-lg text-white font-semibold text-sm sm:text-base transition-all duration-200 shadow-lg ${
                      !isFormValid() || isLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 active:scale-95"
                    }`}
                  >
                    {isLoading ? (
                      <div className="flex items-center justify-center space-x-2">
                        <span className="text-xs sm:text-sm">Sending OTP...</span>
                      </div>
                    ) : (
                      "Create Account"
                    )}
                  </button>

                  {/* Login Link */}
                  <div className="text-center pt-2 border-t border-gray-100">
                    <p className="text-gray-600 text-xs sm:text-sm">
                      Already have an account?{" "}
                      <button
                        onClick={() => {
                          setShowPage(false);
                          setTimeout(() => {
                            dispatch(closeSignupModal());
                            dispatch(openLoginModal());
                          }, 300);
                        }}
                        className="font-semibold text-teal-600 hover:text-teal-700 transition-colors underline"
                      >
                        Log In
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ==================== TABLET & DESKTOP VIEW (≥ 768px) ==================== */}
        <div
          className={`hidden md:block absolute top-1/2 left-1/2 transform 
            -translate-x-1/2 -translate-y-1/2 bg-white shadow-2xl outline-none rounded-2xl 
            w-[75vw] lg:w-[60vw] xl:w-[50vw] 2xl:w-[50vw] max-h-[95vh] overflow-y-auto 
            transition-all duration-300
            ${showPage ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}
        >
          <CloseIcon
            onClick={() => {
              setShowPage(false);
              setTimeout(() => dispatch(closeSignupModal()), 300);
            }}
            className="float-right relative w-6 h-6 lg:w-7 lg:h-7 top-2 right-2 cursor-pointer rounded-full hover:bg-gray-100 transition-all duration-200"
          />

          <div className="flex flex-col lg:flex-row justify-between items-stretch gap-0">
            {/* Image Section */}
            <div className="hidden lg:flex items-center justify-center lg:w-1/2 bg-gradient-to-br from-blue-50 to-teal-50 rounded-l-2xl overflow-hidden">
              <img
                src={LoginImg}
                alt="Doctor"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Content Section */}
            <div className="w-full lg:w-1/2 px-5 lg:px-7 py-5 lg:py-7">
              {verifyOtpPage ? (
                // ---------- Desktop OTP Verification ----------
                <div className="text-center space-y-5 lg:space-y-6">
                  <div>
                    <h1 className="text-2xl lg:text-3xl font-bold text-gray-900">
                      Verify Now
                    </h1>
                    <p className="text-gray-600 text-sm lg:text-base mt-1 lg:mt-2">
                      A verification code has been sent to your mobile number
                    </p>
                  </div>

                  <form
                    onSubmit={handleVerifyAndRegister}
                    className="space-y-4 lg:space-y-5"
                  >
                    <div className="space-y-3 lg:space-y-4">
                      <TextField
                        required
                        label="Mobile No"
                        name="phoneNo"
                        value={formData.phoneNo}
                        fullWidth
                        disabled
                        size="small"
                        InputProps={{
                          startAdornment: <span className="mr-2">+91</span>,
                        }}
                        onKeyDown={(e) => e.stopPropagation()}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "44px",
                            borderRadius: "10px",
                            fontSize: "14px",
                          },
                          "& .MuiInputLabel-root": { fontSize: "14px" },
                        }}
                      />

                      <TextField
                        required
                        label="Enter Code"
                        name="otp"
                        value={formDataOtp.otp}
                        fullWidth
                        size="small"
                        onChange={handleChangeOtp}
                        onKeyDown={(e) => e.stopPropagation()}
                        inputProps={{ inputMode: "numeric", maxLength: 6 }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "44px",
                            borderRadius: "10px",
                            fontSize: "14px",
                          },
                          "& .MuiInputLabel-root": { fontSize: "14px" },
                        }}
                      />
                    </div>

                    <div className="text-center py-2">
                      {timer > 0 ? (
                        <p className="text-gray-600 text-sm lg:text-base">
                          Resend code in{" "}
                          <span className="font-semibold text-teal-600">
                            {timer}s
                          </span>
                        </p>
                      ) : (
                        <button
                          type="button"
                          onClick={handleSendOtp}
                          className="text-sm lg:text-base font-semibold text-teal-600 hover:text-teal-700 transition-colors underline"
                        >
                          Resend OTP
                        </button>
                      )}
                    </div>

                    {error && (
                      <div className="bg-red-50 border-l-4 border-red-400 p-3 lg:p-4 rounded-lg">
                        <p className="text-red-700 text-sm font-medium">
                          {error}
                        </p>
                      </div>
                    )}

                    <button
                      type="submit"
                      disabled={isLoading}
                      className={`w-full py-2.5 lg:py-3 rounded-lg text-white font-semibold text-base transition-all ${
                        isLoading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700"
                      }`}
                    >
                      {isLoading ? "Verifying..." : "Submit"}
                    </button>

                    <button
                      type="button"
                      onClick={() => {
                        setVerifyOtpPage(false);
                        setError("");
                      }}
                      className="w-full py-2.5 lg:py-3 bg-white border-2 border-gray-200 text-gray-700 rounded-lg font-semibold text-base hover:bg-gray-50"
                    >
                      ← Go Back
                    </button>
                  </form>
                </div>
              ) : (
                // ---------- Desktop Registration Form ----------
                <div className="text-center space-y-5 lg:space-y-4">
                  <div>
                    <h1 className="text-2xl lg:text-2xl font-bold text-gray-900">
                      Welcome to RAMA Hospital
                    </h1>
                    <p className="text-gray-600 text-sm lg:sm mt-1 lg:mt-2">
                      Create your account to get started
                    </p>
                  </div>

                  <div className="space-y-3 lg:space-y-3 text-left">
                    {/* Full Name & Mobile in 2 columns */}
                    <div className="grid grid-cols-2 gap-2 lg:gap-3">
                      <TextField
                        required
                        label="Full Name"
                        name="patientName"
                        value={formData.patientName}
                        size="small"
                        onChange={handleChange}
                        onKeyDown={(e) => e.stopPropagation()}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "40px",
                            borderRadius: "10px",
                            fontSize: "13px",
                          },
                          "& .MuiInputLabel-root": { fontSize: "13px" },
                        }}
                      />

                      {/* ✅ FIXED Mobile Number - Desktop View */}
                      <TextField
                        required
                        label="Mobile No"
                        name="phoneNo"
                        value={formData.phoneNo}
                        size="small"
                        onChange={handlePhoneChange}
                        onKeyDown={(e) => e.stopPropagation()}
                        error={!isMobileValid}
                        // helperText={mobileHelperText}
                        inputProps={{
                          inputMode: "numeric",
                          maxLength: 10,
                          pattern: "[6-9][0-9]{9}",
                        }}
                        InputProps={{
                          startAdornment: <span className="mr-2">+91</span>,
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "40px",
                            borderRadius: "10px",
                            fontSize: "13px",
                          },
                          "& .MuiInputLabel-root": { fontSize: "13px" },
                        }}
                      />
                    </div>

                    {/* DOB & Gender in 2 columns */}
                    <div className="grid grid-cols-2 gap-2 lg:gap-3">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Date of Birth"
                          value={formData.dob}
                          onChange={handleDateChange}
                          maxDate={dayjs()}
                          minDate={dayjs().subtract(100, "year")}
                          slots={{
                            textField: (params) => (
                              <TextField
                                {...params}
                                required
                                size="small"
                                onKeyDown={(e) => e.stopPropagation()}
                                sx={{
                                  "& .MuiInputBase-root": {
                                    height: "40px",
                                    borderRadius: "10px",
                                    fontSize: "13px",
                                  },
                                  "& .MuiInputLabel-root": { fontSize: "13px" },
                                }}
                              />
                            ),
                          }}
                          slotProps={{ popper: { sx: { zIndex: 1400 } } }}
                        />
                      </LocalizationProvider>

                      <FormControl size="small">
                        <InputLabel
                          id="gender-label"
                          sx={{ fontSize: "13px" }}
                        >
                          Gender
                        </InputLabel>
                        <Select
                          labelId="gender-label"
                          name="gender"
                          value={formData.gender}
                          onChange={handleChange}
                          label="Gender"
                          sx={{
                            borderRadius: "10px",
                            fontSize: "13px",
                          }}
                        >
                          <MenuItem value="M">Male</MenuItem>
                          <MenuItem value="F">Female</MenuItem>
                          <MenuItem value="O">Other</MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    {/* Email full width */}
                    <TextField
                      label="Email"
                      name="email"
                      value={formData.email}
                      fullWidth
                      size="small"
                      onChange={handleChange}
                      onKeyDown={(e) => e.stopPropagation()}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "40px",
                          borderRadius: "10px",
                          fontSize: "13px",
                        },
                        "& .MuiInputLabel-root": { fontSize: "13px" },
                      }}
                    />

                    {/* City full width */}
                    <TextField
                      required
                      label="City"
                      name="address"
                      value={formData.address}
                      fullWidth
                      size="small"
                      onChange={handleChange}
                      onKeyDown={(e) => e.stopPropagation()}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "40px",
                          borderRadius: "10px",
                          fontSize: "13px",
                        },
                        "& .MuiInputLabel-root": { fontSize: "13px" },
                      }}
                    />

                    {/* OTP Method Selection */}
                    <div className="space-y-2 py-3 bg-blue-50 border border-blue-200 rounded-lg p-3 text-left">
                      <p className="font-semibold text-xs text-gray-700">
                        Send OTP via
                      </p>
                      <div className="flex items-center gap-4 lg:gap-6">
                        {/* SMS Option */}
                        <label
                          className="flex items-center gap-2 cursor-pointer group"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOtpMethod("sms");
                          }}
                        >
                          <div className="relative flex items-center justify-center">
                            <div
                              className={`w-4 h-4 rounded-full border-2 transition-all duration-200 ${
                                otpMethod === "sms"
                                  ? "border-teal-600 bg-teal-50"
                                  : "border-gray-300 bg-white group-hover:border-teal-400"
                              }`}
                            >
                              {otpMethod === "sms" && (
                                <div className="absolute inset-0 flex items-center justify-center">
                                  <div className="w-2 h-2 rounded-full bg-teal-600"></div>
                                </div>
                              )}
                            </div>
                          </div>
                          <span className="text-xs">SMS</span>
                        </label>

                        {/* WhatsApp Option */}
                        <label
                          className="flex items-center gap-2 cursor-pointer group"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOtpMethod("whatsapp");
                          }}
                        >
                          <div className="relative flex items-center justify-center">
                            <div
                              className={`w-4 h-4 rounded-full border-2 transition-all duration-200 ${
                                otpMethod === "whatsapp"
                                  ? "border-teal-600 bg-teal-50"
                                  : "border-gray-300 bg-white group-hover:border-teal-400"
                              }`}
                            >
                              {otpMethod === "whatsapp" && (
                                <div className="absolute inset-0 flex items-center justify-center">
                                  <div className="w-2 h-2 rounded-full bg-teal-600"></div>
                                </div>
                              )}
                            </div>
                          </div>
                          <span className="text-xs">WhatsApp</span>
                        </label>
                      </div>
                    </div>

                    {/* Terms and Conditions */}
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-1">
                      <div className="flex items-start gap-2 lg:gap-3">
                        <input
                          type="checkbox"
                          id="terms"
                          checked={acceptedTerms}
                          onChange={(e) => setAcceptedTerms(e.target.checked)}
                          className="cursor-pointer mt-1 w-3 h-3"
                        />
                        <div className="text-xs text-blue-700 leading-relaxed">
                          Get updates on Whatsapp, I agree to all the{" "}
                          <Link
                            to="/privacy"
                            className="text-teal-600 font-medium hover:underline"
                          >
                            Privacy Policy
                          </Link>{" "}
                          &{" "}
                          <Link
                            to="/terms_conditions"
                            className="text-teal-600 font-medium hover:underline"
                          >
                            T&C
                          </Link>
                          .
                        </div>
                      </div>
                    </div>

                    {error && (
                      <div className="bg-red-50 border-l-4 border-red-400 p-2 lg:p-3 rounded-lg">
                        <p className="text-red-700 text-xs lg:text-sm font-medium">
                          {error}
                        </p>
                      </div>
                    )}

                    {/* Create Account Button */}
                    <button
                      onClick={handleSendOtp}
                      disabled={!isFormValid() || isLoading}
                      className={`w-full py-2.5 lg:py-3 rounded-lg text-white font-semibold text-base transition-all ${
                        !isFormValid() || isLoading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700"
                      }`}
                    >
                      {isLoading ? "Sending OTP..." : "Create Account"}
                    </button>

                    {/* Login Link */}
                    <div className="text-center pt-1">
                      <p className="text-gray-600 text-sm">
                        Already have an account?{" "}
                        <button
                          onClick={() => {
                            setShowPage(false);
                            setTimeout(() => {
                              dispatch(closeSignupModal());
                              dispatch(openLoginModal());
                            }, 300);
                          }}
                          className="font-semibold text-teal-600 hover:text-teal-700 transition-colors underline"
                        >
                          Log In
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}
